import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';
import { DataService, AppService, LocalStorageService } from 'src/app/service';
import { TranslateService } from '@ngx-translate/core';
import * as dd from 'dingtalk-jsapi'; // 引入钉钉jsapi

@Component({
  selector: 'app-classification-select',
  templateUrl: './classification-select.component.html',
  styleUrls: ['./classification-select.component.scss'],
})
export class ClassificationSelectComponent implements OnInit {
  returnSpaceTree = false; // 是否把spaceTree结构也返回
  showInvalid = false; // 是否显示无效的节点
  pageTitle = '';
  placeholderMessage = '';
  search: string; // 搜索文本
  originalOptionList = []; // 原始结构数据
  searchList = []; // 筛选使用数据
  optionList = []; // 树形结构数据

  selected: any; // 选择的数据
  selectedId = []; // 选择数据的级联ID

  optionCrumbs = []; // 组织架构面包屑
  instantClose;
  needSelectLastOne;   // 是否必须选择最低层级
  basicOptionList;
  constructor(
    private navParams: NavParams,
    private modalController: ModalController,
    private appService: AppService,
    private dataService: DataService,
    public cd: ChangeDetectorRef,
    private translateService: TranslateService,
    public localStorageService: LocalStorageService
  ) {
    let params = this.navParams.data;
    this.pageTitle = params.pageTitle ? params.pageTitle : '';
    this.placeholderMessage = params.placeholderMessage ? params.placeholderMessage : '';
    this.originalOptionList = params.optionList ? params.optionList : [];

    this.selected = params.selected ? params.selected : null;
    this.showInvalid = params.showInvalid ? params.showInvalid : false;
    this.returnSpaceTree = params.returnSpaceTree ? params.returnSpaceTree : false;
    this.needSelectLastOne = true
    // params.needSelectLastOne ? params.needSelectLastOne : false;
  }

  ngOnInit() {
    // Ionic modal 的 componentProps 是在构造函数之后通过 Object.assign 直接赋值到实例属性上的，
    // 此时才是 pageTitle 的最终原始值（翻译 key），因此翻译必须放在这里而不是构造函数里。
    this.pageTitle = this.translateService.instant(this.pageTitle);
    // 设置标题
    document.getElementsByTagName('title').item(0).innerText = this.pageTitle;
    if (dd.env.platform !== 'notInDingTalk') {
      dd.biz.navigation.setTitle({
        title: this.pageTitle // 钉钉设置导航栏标题
      });
    }
    this.optionList = this.originalOptionList;

    this.basicOptionList = JSON.parse(JSON.stringify(this.optionList));
    this.searchList = JSON.parse(JSON.stringify(this.optionList));
    this.initPageData();
    this.cd.detectChanges();

    const that = this;
    window.onpopstate = function () {
      const a = document.getElementsByTagName('app-corp-select');
      if (a.length > 0) {
        setTimeout(() => {
          that.modalController.dismiss();
        }, 100)
      }
    };
  }

  // 编辑进入：配置初始面包屑导航和数据
  initPageData() {

    if (this.optionList.length > 0 && this.selected) {
      // 配置面包屑
      this.setCrumbs(this.optionList, this.selected);
      // 追加面包屑默认目录
      this.optionCrumbs.unshift({
        value: {
          code: this.pageTitle,
        },
        list: this.searchList,
      })
      // 回填默认下拉
      if (this.optionCrumbs.length > 1) {
        const lastData = this.optionCrumbs[this.optionCrumbs.length - 1];
        this.optionList = lastData.list;
        this.searchList = JSON.parse(JSON.stringify(this.optionList));
      }
    } else {
      // 默认配置-根目录
      this.optionCrumbs = [{
        value: { code: this.pageTitle },
        list: this.searchList,
      }]
    }
  }

  // 递归获取选中的数据
  setCrumbs(arr, nodeId) {
    if (!arr || arr.length === 0) { // 判断数据是否存在并且不为空，如果是，则直接返回空数组
      return [];
    }
    const filteredData = []; // 定义过滤后的数据数组
    for (let i = 0; i < arr.length; i++) { // 遍历每个节点
      const node = arr[i];
      if (node.code == nodeId) {
        filteredData.push(node.code);
      }
      if (node.childSpace && node.childSpace.length > 0) { // 如果当前节点存在子节点，则递归遍历子节点
        const filteredChildSpace = this.setCrumbs(node.childSpace, nodeId); // 对子节点进行递归过滤
        if (filteredChildSpace.length > 0) { // 如果过滤后的子节点不为空，则将该节点加入到过滤后的数据数组中，并将过滤后的子节点作为其 children 属性的值
          filteredData.push({
            code: node.code,
            children: filteredChildSpace,
          });
          // 构造面包屑导航
          if (node.code !== nodeId) {
            this.optionCrumbs.unshift({
              value: node,
              list: node.childSpace,
            })
          }
        }
      }
    }
    return filteredData;
  }

  // 点击选择地点
  clickOption(value) {
    this.selected = value;
  }

  // 下一级
  nextLevel(value) {
    this.optionCrumbs.push({
      value: value, // 当前选择数据
      list: JSON.parse(JSON.stringify(this.basicOptionList)) // 保存数据结构，返回上级时使用
    });
    this.optionList = value.childSpace;
    this.search = '';
    this.searchList = JSON.parse(JSON.stringify(this.optionList));
  }

  // 点击组织架构面包屑
  clickOptionCrumbs(item, index) {
    // 找到选中元素的下拉层级
    this.optionList = this.basicOptionList;
    this.search = '';
    this.searchList = JSON.parse(JSON.stringify(this.optionList));
    if (index == 1) {
      this.optionCrumbs = this.optionCrumbs.splice(0, index);
    } else {
      this.optionCrumbs = [{ list: JSON.parse(JSON.stringify(this.basicOptionList)), value: { code: this.pageTitle } }];
      console.log(this.optionCrumbs);
    }

  }

  // 搜索组织架构
  searchOrg() {
    if (this.search && this.optionList.length > 0) {
      console.log(this.search);
      this.optionList = this.optionList.filter(item => {
        console.log(item.code);

        // 不区分大小写
        // const spaceName = item.spaceName.toUpperCase();
        // const search = this.search.toUpperCase();
        // return spaceName.indexOf(search) !== -1;
      })
    } else {
      this.optionList = this.searchList;
    }
  }

  // 确认
  async confirm() {
    const confimData = JSON.parse(JSON.stringify(this.selected));
    if (confimData.childSpace && confimData.childSpace.length > 0) {
      this.appService.toastTip(this.translateService.instant('shared_components.common.please_select_last_finding_category'), true);
      return;
    }
    delete confimData.childSpace;
    if (this.returnSpaceTree) {
      const tempArr = [];
      console.log(this.optionCrumbs);
      this.optionCrumbs.forEach((item, index) => {
        if (index !== 0) {
          tempArr.push(item.value.code ? item.value.code : item.value);
        }
      });
      tempArr.push(confimData.code ? confimData.code : confimData);
      await this.modalController.dismiss({
        spaceDTO: confimData.code ? confimData : { code: confimData },
        spaceTree: tempArr,
      });
    } else {
      await this.modalController.dismiss(confimData);
    }
    history.back();
  }

  async cancel() {
    await this.modalController.dismiss();
    history.back();
  }

  // 获取有效节点数量
  getValidNum(list) {
    let n = 0;
    list.forEach(item => {
      // if (item.status === '_SYS_A9_1') {
      n++;
      // }
    });
    if (this.showInvalid) { // 显示无效节点
      return 1;
    } else {
      return n;
    }
  }
}
